import React, { useState, useCallback } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import RealTimeSoundLevels from "components/RealTimeSoundLevels";
import SLMSidebar from "components/SLMSidebar";
import { MqttProvider } from "context/MQTTContext";
import { useLocation } from "react-router-dom";

const SoundLevelMeter = () => {
    const searchParams = new URLSearchParams(useLocation().search);
    const topicPrefix = searchParams.get("topicPrefix") || "defaultPrefix";
    const [resetMaxSignal, setResetMaxSignal] = useState(0);
    const [referenceCurve, setReferenceCurve] = useState<number[] | null>(null);

    // State to manage commands and settings from the sidebar
    const [recording, setRecording] = useState(false);
    const [chartSettings, setChartSettings] = useState({ /* initial settings */ });

    const handleResetMaxLevels = useCallback(() => {
        // Increment the reset signal to trigger the reset effect in RealTimeSoundLevels.
        setResetMaxSignal(prev => prev + 1);
    }, []);

    // Callbacks for commands triggered by the sidebar
    const handleStartStopRecording = useCallback(() => {
        setRecording(prev => !prev);
        // Additional logic to start/stop recording
    }, []);

    const handleSaveData = useCallback(() => {
        // Logic to save current data
    }, []);

    const handleUpdateChartSettings = useCallback((newSettings: any) => {
        setChartSettings(newSettings);
    }, []);

    const handleUpdateReferenceCurve = useCallback((curve: number[] | null) => {
        setReferenceCurve(curve);
    }, []);

    return (
        <DashboardLayout>
            <MqttProvider topicPrefix={topicPrefix}>
                <div style={{ display: 'flex', height: '100%' }}>
                    {/* Main content area */}
                    <div style={{ flex: 1, paddingRight: '16px' }}>
                        <RealTimeSoundLevels chartSettings={chartSettings} recording={recording} resetMaxSignal={resetMaxSignal} referenceCurve={referenceCurve} />
                    </div>
                    {/* Sidebar navigation */}
                    <SLMSidebar
                        recording={recording}
                        onStartStop={handleStartStopRecording}
                        onSaveData={handleSaveData}
                        onUpdateChartSettings={handleUpdateChartSettings}
                        onResetMaxLevels={handleResetMaxLevels}
                        onUpdateReferenceCurve={handleUpdateReferenceCurve}
                    />
                </div>
            </MqttProvider>
        </DashboardLayout>
    );
};

export default SoundLevelMeter;
